import { useStatsigClient } from '@statsig/react-bindings'
import { NEW_PLAYBAR } from 'constants/featureFlags'

/**
 * Resolves the `new_playbar` Statsig gate.
 *
 * Stays false while Statsig is still loading so the legacy playbar remains the
 * default and gated users never flash the old layout before the gate resolves.
 */
const useNewPlaybar = () => {
  const { checkGate, isLoading: isStatsigLoading } = useStatsigClient()

  return !isStatsigLoading && checkGate(NEW_PLAYBAR)
}

export default useNewPlaybar
